// @ts-nocheck TODO: fix it
import BigNumber from 'bignumber.js'
import _ from 'lodash'
import qs from 'qs'
import { ActiveFiltersInterface, ActiveFiltersPriceInterface, ProductFiltersInterface } from '../interfaces/FiltersInterface'

export enum ATTRIBUTE_ID {
  FLAG = 17,
}

export const SINGLE_VALUE_ATTRIBUTES = [ATTRIBUTE_ID.FLAG]

export const AVAILABLE_FILTERS: { [key: string]: object | string[] } = {
  attributes: {},
  pager: ['page', 'size'],
  price: ['min', 'max', 'saleItems'],
  sizes: [],
  sizeKeys: [],
}

export enum FILTER_FLAT {
  SIZES = 'sizes',
}

export enum FILTER_RANGE {
  PRICE = 'price',
}

const parseFilters = (params: ProductFiltersInterface) => {
  const result: ActiveFiltersInterface = {} as ActiveFiltersInterface
  for (const filterKey in AVAILABLE_FILTERS) {
    if (filterKey in params) {
      const availableKeys = AVAILABLE_FILTERS[filterKey]
      const param = params[filterKey]
      if (_.isArray(availableKeys)) {
        if (availableKeys.length > 0) {
          result[filterKey] = {}
          for (const availableKey of availableKeys) {
            if (availableKey in param) {
              result[filterKey][availableKey] = param[availableKey]
            }
          }
        } else {
          result[filterKey] = []
          for (const key in param) {
            result[filterKey].push(param[key])
          }
        }
      } else if (_.isObject(availableKeys)) {
        result[filterKey] = param
      }
    }
  }

  return result
}

export const loadFiltersFromQueryParams = (queryParams: string): ActiveFiltersInterface => {
  const params = qs.parse(queryParams, { ignoreQueryPrefix: true, parseArrays: false })
  return parseFilters(params)
}

export const getAttributesHtml = (filters: ProductFiltersInterface) =>
  filters?.attributes?.filter(item => item.visible).sort((a, b) => a.position - b.position)

export const isFlatAttributeChecked = (activeFilters: ActiveFiltersInterface, name: keyof ActiveFiltersInterface, val: string | number) => {
  return activeFilters[name] && (activeFilters[name] as (string | number)[]).find((itemId: string | number) => itemId == val) !== undefined
}

export const isAttributeChecked = (activeFilters: ActiveFiltersInterface, attributeId: number, valueId: number) => {
  if (!activeFilters['attributes']?.[attributeId]?.[valueId]) {
    return false
  }
  const value = parseInt(activeFilters['attributes'][attributeId][valueId], 10)
  return Number.isNaN(value) || value > 0
}

export const getFlatFilters = (params: string) => {
  const flatFilters = loadFiltersFromQueryParams(params)
  if (_.isObject(flatFilters.attributes)) {
    const newFilters = Object.keys(flatFilters.attributes)
      .map(attributeId => {
        const values = flatFilters.attributes![attributeId]
        return Object.keys(values)
          .filter(valueId => parseInt(values[valueId], 10) > 0)
          .map(valueId => `${attributeId}_${valueId}`)
      })
      .reduce((prevValue, currValue) => prevValue.concat(currValue), [])
    flatFilters.attributes = newFilters
  }
  return flatFilters
}

export const hasActiveFilters = (filters: ActiveFiltersInterface) => Object.entries(filters).length > 0

export const countActiveFilters = (filters: ActiveFiltersInterface) => {
  return (
    Object.entries(filters.attributes || {}).reduce((acc, cur) => acc + Object.entries(cur[1]).filter(val => val[1] === '1').length, 0) +
    (filters.sizeKeys || []).length +
    Object.entries(filters.price || {}).length
  )
}

export const putRangeFilter = (
  rangeFilters: ActiveFiltersInterface,
  name: string,
  min: string | null,
  max: string | null,
  extraParams?: object,
) => {
  if (!_.has(AVAILABLE_FILTERS, name) || !(Object.values(FILTER_RANGE) as string[]).includes(name)) {
    return rangeFilters
  }
  const _name = name as keyof ActiveFiltersInterface
  const _rangeFilters = _.cloneDeep(rangeFilters) as { [key: string]: ActiveFiltersPriceInterface }

  const minNumber = min != null ? new BigNumber(Math.max(Number(min), 0)) : null
  const maxNumber = max != null ? new BigNumber(Math.max(Number(max), 0)) : null
  const range: {
    min?: BigNumber
    max?: BigNumber
  } = {}
  const finalRange: {
    min?: string
    max?: string
  } = {}

  if (minNumber !== null && !minNumber.isNaN()) {
    range.min = minNumber
  }
  if (maxNumber !== null && !maxNumber.isNaN()) {
    range.max = maxNumber
  }
  if (range.min != null && range.max != null && range.min.isGreaterThan(range.max) && range.max.isGreaterThan(0)) {
    range.max = [range.min, (range.min = range.max)][0]
  }
  if (range.min != null) {
    finalRange.min = range.min.toFixed(2)
  }
  if (range.max != null) {
    finalRange.max = range.max.toFixed(2)
  }

  _rangeFilters[_name] = finalRange
  if (extraParams) {
    _rangeFilters[_name] = { ..._rangeFilters[_name], ...extraParams }
  }
  return _rangeFilters
}

export const putFlatAttribute = (flatAttributeFilters: ActiveFiltersInterface, name: string, valueId: number | string, add?: boolean) => {
  const _name = (name === FILTER_FLAT.SIZES ? 'sizeKeys' : name) as keyof ActiveFiltersInterface
  if (!_.has(AVAILABLE_FILTERS, _name) || !(Object.values(FILTER_FLAT) as string[]).includes(name)) {
    return flatAttributeFilters
  }
  const _flatAttributeFilters = _.cloneDeep(flatAttributeFilters) as { [key: string]: string[] }
  if (!_.has(_flatAttributeFilters, _name)) {
    _flatAttributeFilters[_name] = []
  }
  if (add && !_flatAttributeFilters[_name].includes(`${valueId}`)) {
    _flatAttributeFilters[_name].push(`${valueId}`)
  } else {
    _flatAttributeFilters[_name] = _flatAttributeFilters[_name].filter((itemId: number | string) => itemId != valueId)
  }
  return _flatAttributeFilters
}

export const putAttribute = (attributeFilters: ActiveFiltersInterface, attributeId: number, valueId: number, checked: boolean) => {
  const _attributeFilters = _.cloneDeep(attributeFilters)
  if (!_.has(_attributeFilters, 'attributes')) {
    _attributeFilters['attributes'] = {}
  }
  if (!_.has(_attributeFilters['attributes'], attributeId)) {
    _attributeFilters.attributes![attributeId] = {}
  }
  if (checked) {
    _attributeFilters.attributes![attributeId][valueId] = '1'
  } else if (_.has(_attributeFilters, `attributes.${attributeId}.${valueId}`)) {
    delete _attributeFilters.attributes![attributeId][valueId]
  }
  return _attributeFilters
}

export const groupSizeFilter = (filters: ProductFiltersInterface) => {
  const groupedFilters = _.cloneDeep(filters)
  if (groupedFilters && groupedFilters.sizes) {
    const temp = _.groupBy(groupedFilters.sizes, s => s.sizeKey)
    groupedFilters.sizes = _.map(temp, g => {
      const [first, ...rest] = _.uniqBy(g, s => s.label)
      const restLabels = rest.map(s => `(${s.label})`).join(' ')
      first.label = `${first.label} ${restLabels}`
      return first
    })
  }
  return groupedFilters
}

export const buildQueryParams = (data: ActiveFiltersInterface) => {
  return qs.stringify(data, { encodeValuesOnly: true })
}
